import type { ReactNode } from 'react';
import { ArcPanel } from '../components/arc/primitives/arc-primitives';
import styles from './affilmaster-detail-fields.module.css';

export function AffilmasterDetailFieldGroup({ title, children }: { title: string; children: ReactNode }) {
  return (
    <section className={styles.group}>
      <h2 className={styles.title}>{title}</h2>
      <div className={styles.grid}>{children}</div>
    </section>
  );
}

export function AffilmasterDetailSectionHeader({ title, description, action }: {
  title: string;
  description?: string;
  action?: ReactNode;
}) {
  return (
    <header className={styles.sectionHeader}>
      <div>
        <h2>{title}</h2>
        {description && <p>{description}</p>}
      </div>
      {action}
    </header>
  );
}

export function AffilmasterDetailField({ label, value, code, link, prefix }: {
  label: string;
  value?: ReactNode;
  code?: string;
  link?: string | null;
  prefix?: ReactNode;
}) {
  const empty = code == null && (value == null || value === '');
  return (
    <ArcPanel as="div" className={styles.field}>
      <div className={styles.label}>{label}</div>
      <div className={styles.value}>
        {!empty && prefix}
        {code != null ? <code className={styles.code}>{code}</code>
          : empty ? <span className={styles.empty}>—</span>
          : link ? <a href={link} target={link.startsWith('mailto:') || link.startsWith('tel:') ? undefined : '_blank'} rel={link.startsWith('mailto:') || link.startsWith('tel:') ? undefined : 'noreferrer'}>{value}</a>
          : value}
      </div>
    </ArcPanel>
  );
}
